import * as React from 'react';

const CheckmarkShield12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.342 11.714c.419.203.897.203 1.316 0C8.016 11.057 11 9.245 11 6V3.206a2 2 0 0 0-1.323-1.882l-3-1.08a2 2 0 0 0-1.354 0l-3 1.08A2 2 0 0 0 1 3.206V6c0 3.245 2.984 5.057 4.342 5.714m2.936-7.219a.5.5 0 0 0-.707 0L5.98 6.086a.25.25 0 0 1-.354 0l-.883-.883a.5.5 0 1 0-.708.707L5.626 7.5a.25.25 0 0 0 .354 0l2.298-2.298a.5.5 0 0 0 0-.707",
    clipRule: "evenodd"
  }
));
CheckmarkShield12.Size = 12;
CheckmarkShield12.Title = "CheckmarkShield";

export { CheckmarkShield12 as default };
